<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VOqGvI/tc-custom/9780830890842.jpg?1696024626970" alt="This image is the cover for the book Between One Faith and Another"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Between One Faith and Another
      </h1>
      <p class="bookDescription body article font2">
        <p>How do we make sense of the world's different religions? In today's globalized society, religion is deeply intertwined with every issue we see on the news. But talking about multiple religions can be contentious. Are different faiths compatible somehow? And how can we know whether one religion is more true than another? In this creative thought experiment, Peter Kreeft invites us to encounter dialogues on the world's great faiths. His characters Thomas Keptic and Bea Lever are students in Professor Fesser's course on world religions, and the three explore the content and distinctive claims of each. Together they probe the plausibility of major religions, from Hinduism and Buddhism to Christianity and Islam. Along the way they explore how religions might relate to each other and to what extent exclusivism or inclusivism might make sense. Ultimately Kreeft gives us helpful tools for thinking fairly and critically about competing religious beliefs. If the religions are different kinds of music, do they together make harmony or cacophony? Decide for yourself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Kreeft
      </h2>
      
      <p class="authorDescription body article"><p>Peter J. Kreeft (Ph.D., Fordham University) is professor of philosophy at Boston College where he has taught since 1965. A popular lecturer, he has also taught at many other colleges, seminaries and educational institutions in the eastern United States. Kreeft has written more than fifty books, including <em>The Best Things in Life, The Journey, How to Win the Culture War</em> and, with Ronald Tacelli, <em>Handbook of Christian Apologetics.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b47d729e